import axios from "axios";

const axiosInstance = axios.create({
  // local version of amazon server
  // baseURL: "http://127.0.0.1:5001/clone-27f53/us-central1/api",

  //deployed version of amazon server on render.com
  baseURL: "https://amazon-api-deploy-nmex.onrender.com",
});
export { axiosInstance };
